export enum BranchDeliverySystemType {
  PER_DIRECT_DISTANCE = 'PerDirectDistance',
  PER_DIRECT_DISTANCE_SEGMENT = 'PerDirectDistanceSegment'
}
